import React, { useState, useRef, useEffect } from "react";
import { Ellipsis } from 'lucide-react';
import './EllipsisMenu.css';

const EllipsisMenu = ({ item, onView, onEdit, onDelete, onDownload, permissions = {} }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative " ref={menuRef}>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(!isOpen);
                }}
                className="p-1 rounded hover:bg-gray-100"
                aria-label="More options"
            >
                <Ellipsis color="#ff176b" size={14} strokeWidth={1} />
            </button>

            {isOpen && (
                <div className="position-absolute mt-2 bg-white rounded border ellipsis-div d-flex flex-col" style={{ zIndex: '9999', left: '4%', top: '50%', width: '130px' }}>
                    <div className="py-1 d-flex  flex-column w-100">
                        {permissions.canView && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onView();
                                    setIsOpen(false);
                                }}
                                className=" w-100 text-start px-2 py-2 btn-hover"
                            >
                                View
                            </button>
                        )}
                        {permissions.canEdit && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit();
                                    setIsOpen(false);
                                }}
                                className="w-100 text-start px-2 py-2 btn-hover"
                            >
                                Edit
                            </button>)}
                        {permissions.canDelete && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete();
                                    setIsOpen(false);
                                }}
                                className="display-block w-100 text-start px-2 py-2 btn-hover"
                            >
                                Delete
                            </button>)}
                        {permissions.canDownload && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDownload();
                                    setIsOpen(false);
                                }}
                                className="display-block w-100 text-start px-2 py-2 btn-hover"
                            >
                                Download
                            </button>)}
                    </div>
                </div>
            )}
        </div>
    );
};

export default EllipsisMenu;
